import { render, staticRenderFns } from "./TermsOfService1123039.vue?vue&type=template&id=60cc7ed3&scoped=true&"
import script from "./TermsOfService1123039.vue?vue&type=script&lang=js&"
export * from "./TermsOfService1123039.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfService1123039.vue?vue&type=style&index=0&id=60cc7ed3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc7ed3",
  null
  
)

export default component.exports